<template>
  <div v-if="formaPagamentoProdutos.mensal">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <h5 class="mb-5">Formas de Pagamento</h5>

          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label"
                >Forma de Pagamento - 1 Parcela</label
              >
              <v-select
                :options="formaPagamentoProdutos.entrada.opcoes"
                name="Forma de Pagamento 1 Parcela"
                id="Forma de Pagamento 1 Parcela"
                v-model="formConfirmacao.idFormaPagamentoAVista"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                label="text"
                :class="{
                  'error-select': validateClass('Forma de Pagamento 1 Parcela'),
                }"
                @input="aoSelecionarFormaPagamento('entrada', $event)"
              >
              </v-select>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label"
                >Forma de Pagamento - Mensal</label
              >
              <v-select
                :options="formaPagamentoProdutos.mensal.opcoes"
                name="Forma Pagamento Mensal"
                id="Forma Pagamento Mensal"
                v-model="formConfirmacao.idFormaPagamentoMensal"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                label="text"
                :class="{
                  'error-select': validateClass('Forma Pagamento Mensal'),
                }"
                @input="aoSelecionarFormaPagamento('mensal', $event)"
              >
              </v-select>
            </div>
          </div>

          <div
            class="vx-row"
            v-if="formaPagamentoProdutos.dinheiro.opcoes.length > 0"
          >
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label"
                >Valores Pagos em Dinheiro</label
              >

              <p class="text-sm text-gray-600 mb-1">
                <strong>Produtos:</strong>
                {{
                  formaPagamentoProdutos.dinheiro.opcoes
                    .filter((op) => op.nomeProduto)
                    .map((op) => op.nomeProduto)
                    .filter((v, i, arr) => arr.indexOf(v) === i)
                    .join(', ')
                }}
              </p>
              <v-select
                :options="formaPagamentoProdutos.dinheiro.opcoes"
                name="Forma Pagamento Dinheiro"
                id="Forma Pagamento Dinheiro"
                v-model="formConfirmacao.idFormaPagamentoDinheiro"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                label="text"
                :class="{
                  'error-select': validateClass('Forma Pagamento Mensal'),
                }"
                @input="aoSelecionarFormaPagamento('dinheiro', $event)"
              >
              </v-select>
            </div>
          </div>
        </div>
        <div
          v-if="!diasVencimentoTypeCalendar && exibeDiaVencimentoMensalidade"
          class="vx-col sm:w-1/2 w-full mb-2 sm:mt-10 mt-0"
        >
          <label for="" class="vs-select--label"
            >Dia de Vencimento Mensal</label
          >

          <v-select
            :options="diasDeVencimentoEmpresa"
            name="diaVencimentoMensalidade"
            id="diaVencimentoMensalidade"
            v-model="form.diaVencimentoMensalidade"
            @input="reatribuiDiaVencimento()"
          ></v-select>
        </div>
      </div>
      <div
        v-if="diasVencimentoTypeCalendar && exibeDiaVencimentoMensalidade"
        class="mt-5"
      >
        <h5>Dia de Vencimento Mensal</h5>

        <div class="vx-col mb-2 mt-3">
          <DateRadio
            :diasDisponiveis="diasDeVencimentoEmpresa"
            :diaJaDefinido="dadosProposta.diaVencimentoMensalidade"
            @diaSelecionado="diaSelecionado($event)"
            wFull
          />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import service from './../../services';
import functions from './../../utils/functions';
import locale from './../../locale';
import vSelect from 'vue-select';
import DateRadio from '../../components/date-radio/DateRadio.vue';

export default {
  props: [
    'dadosProposta',
    'produtosSelecionados',
    'recarregaFinanceiro',
    'dadosEmpresa',
  ],
  components: {
    'v-select': vSelect,
    DateRadio,
  },
  watch: {
    buscaFormasPagamentoConfigEmpresa: function (newValue) {
      if (newValue) {
        this.buscaFormasPagamento(
          this.dadosProposta.idEmpresa,
          this.dadosProposta.idProposta,
        );
        this.buscaConfigEmpresa();
      }
    },
  },
  computed: {
    buscaFormasPagamentoConfigEmpresa() {
      return (
        this.dadosProposta.idEmpresa != null &&
        this.dadosProposta.idProposta != null
      );
    },
  },
  data() {
    return {
      functions: functions,
      diasDeVencimentoEmpresa: [],
      listaProdutosMensais: [],
      listaProdutosAAvista: [],
      jsonFacilitadorProdutos: [],
      produtos: [],
      produtosAtualizaModel: [],
      form: {
        diaVencimentoMensalidade: null,
      },
      diasVencimentoTypeCalendar: null,
      formaPagamentoProdutos: {},
      formConfirmacao: {
        idFormaPagamentoAVista: null,
        idFormaPagamentoMensal: null,
        idFormaPagamentoDinheiro: null,
      },
      TIPO_CARTAO_CREDITO: 'Cartão de Crédito',
      exibeDiaVencimentoMensalidade: true,
    };
  },
  methods: {
    async selecionaFormaPagamento() {
      const produtos = this.produtos;
      const { entrada, mensal, dinheiro } = this.formaPagamentoProdutos;

      const findFormaPagamento = (idFormaPagamento, tipo) => {
        return this.formaPagamentoProdutos[tipo].opcoes.find(
          (forma) => forma.value.idTipoPagamentoEmpresa === idFormaPagamento,
        );
      };

      for (const produto of produtos) {
        const idProduto = produto.idProduto || produto.id_produto;

        if (entrada.produtos.includes(idProduto)) {
          const formaPagamento = findFormaPagamento(
            produto.idTipoPagamentoEmpresa,
            'entrada',
          );

          if (entrada.cobrancaApartada) {
            continue;
          }

          if (formaPagamento) {
            this.formConfirmacao.idFormaPagamentoAVista = formaPagamento.value;
            this.aoSelecionarFormaPagamento('entrada', formaPagamento.value);
          }
        }

        if (mensal.produtos.includes(idProduto)) {
          const formaPagamento = findFormaPagamento(
            produto.idTipoPagamentoEmpresa,
            'mensal',
          );

          if (formaPagamento) {
            this.formConfirmacao.idFormaPagamentoMensal = formaPagamento.value;
            this.aoSelecionarFormaPagamento('mensal', formaPagamento.value);
          }
        }

        if (dinheiro.produtos.includes(idProduto)) {
          const formaPagamento = findFormaPagamento(
            produto.idTipoPagamentoEmpresa,
            'dinheiro',
          );
          if (formaPagamento) {
            this.formConfirmacao.idFormaPagamentoDinheiro =
              formaPagamento.value;
            this.aoSelecionarFormaPagamento('dinheiro', formaPagamento.value);
          }
        }
      }
    },
    reatribuiDiaVencimento() {
      this.emitChangeVencimento(this.form.diaVencimentoMensalidade);
    },
    reatribuiFormaPagamento(tipo) {
      this.produtos.forEach((produto) => {
        const findProduto = this.formaPagamentoProdutos[tipo].produtos.find(
          (idProduto) => idProduto === produto.idProduto,
        );
        if (findProduto) {
          if (tipo === 'entrada') {
            produto.idTipoPagamentoEmpresa =
              this.formConfirmacao.idFormaPagamentoAVista.idTipoPagamentoEmpresa;
            produto.nomePagamento =
              this.formConfirmacao.idFormaPagamentoAVista.tipoPagamento;
          }

          if (tipo === 'mensal') {
            produto.idTipoPagamentoEmpresa =
              this.formConfirmacao.idFormaPagamentoMensal.idTipoPagamentoEmpresa;
            produto.nomePagamento =
              this.formConfirmacao.idFormaPagamentoMensal.tipoPagamento;
          }

          if (tipo === 'dinheiro') {
            produto.idTipoPagamentoEmpresa =
              this.formConfirmacao.idFormaPagamentoDinheiro.idTipoPagamentoEmpresa;
          }
        }
      });

      this.emitChangedForm('produtosSelecionados', this.produtos);
    },
    emitChangedForm(id, value, formulario = 'dadosProduto') {
      this.$emit('changed', { formulario, id, value });
    },
    emitChangeVencimento(diaVencimento) {
      this.$emit('alteraVencimento', diaVencimento);
    },
    async buscaConfigEmpresa() {
      const {
        diasVencimento,
        qtdDiasVencimentoAvista,
        vencimentoMensalidadeTipo,
      } = this.dadosEmpresa;

      if (diasVencimento) {
        this.diasDeVencimentoEmpresa = functions.verificaEmpresaBemProtege(
          this.dadosProposta.idEmpresa,
        )
          ? this.optionsDiasVencimento(diasVencimento)
          : diasVencimento.split(',');

        this.diasVencimentoTypeCalendar =
          vencimentoMensalidadeTipo === 'calendar';
      }
      if (qtdDiasVencimentoAvista) {
        this.qtdDiasVencimentoAvistaEmpresa = qtdDiasVencimentoAvista;
      }
    },
    optionsDiasVencimento(arrayDiasVencimento) {
      const dataVistoria = new Date();
      const diaDoMesVistoria = dataVistoria.getDate();
      const arrStr = arrayDiasVencimento
        .split(',')
        .map(Number) // aqui converto o array de strings em numbers
        .sort((a, b) => a - b); // ordeno do menor para o maior
      if (diaDoMesVistoria >= 1 && diaDoMesVistoria <= 31) {
        const maxDay = Math.min(diaDoMesVistoria, 31); // seta o maxDay baseado no dia atual garantindo que seja menor que 31

        const novoArrayVencimento = arrStr.filter(
          (element) => element <= maxDay + 4 && maxDay - element <= 5,
        );
        if (diaDoMesVistoria >= 16) novoArrayVencimento.push(10);
        if (diaDoMesVistoria >= 21) novoArrayVencimento.push(15);
        if (diaDoMesVistoria >= 26) novoArrayVencimento.push(20);

        return novoArrayVencimento.sort((a, b) => a - b);
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      this.produtos = this.produtosSelecionados;
      this.form.diaVencimentoMensalidade =
        this.dadosProposta.diaVencimentoMensalidade;
    },
    async buscaFormasPagamento() {
      this.$vs.loading();

      try {
        const { idProposta, idEmpresa } = this.dadosProposta;

        if (!idProposta && !idEmpresa) {
          return;
        }

        const formasPagamento = await service.post(
          'CotacaoAberta',
          'buscarFormasPagamento',
          {
            idEmpresa,
            idProposta,
          },
        );

        await this.buscaConfigEmpresa();
        this.preencheForm();

        this.formaPagamentoProdutos = formasPagamento.data;

        await this.selecionaFormaPagamento();

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível encontrar as formas de Pagamento',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async atualizaModel() {
      this.produtosAtualizaModel = [];
      this.produtosAtualizaModel = this.dadosProposta.produtos;
      await Promise.all(
        this.listaProdutosAAvista.map(async (produtoAVista) => {
          if (produtoAVista.nomeProduto == 'Entrada') {
            const produtoEncontrado = this.produtosAtualizaModel.find(
              (produto) => {
                return (
                  (produto.ismensal == false || produto.isMensal == false) &&
                  produto.idTipoPagamentoEmpresa
                );
              },
            );
            if (produtoEncontrado) {
              let formaEncontrada = produtoAVista.formas.find((forma) => {
                return forma.text == produtoEncontrado.nomePagamento;
              });
              if (formaEncontrada) produtoAVista.valor = formaEncontrada.value;
            }
          } else {
            const produtoEncontrado = this.produtosAtualizaModel.find(
              (produto) => {
                return (
                  (produto.idProduto || produto.id_produto) ==
                  (produtoAVista.idProduto || produtoAVista.id_produto)
                );
              },
            );
            if (produtoEncontrado && produtoEncontrado.idTipoPagamentoEmpresa) {
              let formaEncontrada = produtoAVista.formas.find((forma) => {
                return forma.text == produtoEncontrado.nomePagamento;
              });
              if (formaEncontrada) produtoAVista.valor = formaEncontrada.value;
            }
          }
        }),
      );

      await Promise.all(
        this.listaProdutosMensais.map(async (produtoMensal) => {
          const produtoEncontrado = this.produtosAtualizaModel.find(
            (produto) => {
              return (produto.isMensal || produto.ismensal) == true;
            },
          );
          if (produtoEncontrado.idTipoPagamentoEmpresa) {
            let formaEncontrada = produtoMensal.formas.find((forma) => {
              return forma.text == produtoEncontrado.nomePagamento;
            });
            produtoMensal.valor = formaEncontrada.value;
          }
        }),
      );
    },

    /**
     * Handles the selection of a day for monthly billing.
     *
     * @param {number} dia - The selected day for monthly billing.
     * @returns {void}
     * @emits reatribuiDiaVencimento - Emitted after updating the selected day with the selected day as payload.
     */
    diaSelecionado(dia) {
      this.form.diaVencimentoMensalidade = dia;
      this.reatribuiDiaVencimento();
    },

    aoSelecionarFormaPagamento(tipo, valorSelecionado) {
      const tipoSelecionado = valorSelecionado.tipoPagamento;

      if (!tipoSelecionado) {
        this.formConfirmacao[this.getCampoPorTipo(tipo)] = null;
        return;
      }

      const isCartaoCredito = tipoSelecionado === this.TIPO_CARTAO_CREDITO;
      this.formConfirmacao[this.getCampoPorTipo(tipo)] = valorSelecionado;

      if (!['entrada', 'mensal'].includes(tipo)) {
        this.formConfirmacao[this.getCampoPorTipo(tipo)] = valorSelecionado;
        this.reatribuiFormaPagamento(tipo);
        return;
      }

      this.exibeDiaVencimentoMensalidade = !isCartaoCredito;

      if (isCartaoCredito) {
        const outros = ['entrada', 'mensal'].filter((k) => k !== tipo);

        outros.forEach((key) => {
          const campo = this.getCampoPorTipo(key);
          const opcoes = this.formaPagamentoProdutos[key].opcoes;

          const itemCartao = opcoes.find(
            (o) => o.value.tipoPagamento === this.TIPO_CARTAO_CREDITO,
          );

          if (itemCartao) {
            this.formConfirmacao[campo] = itemCartao.value;
          }
        });

        this.reatribuiFormaPagamento('entrada');
        this.reatribuiFormaPagamento('mensal');

        return;
      }

      const outroTipo = tipo === 'entrada' ? 'mensal' : 'entrada';
      const campoOutro = this.getCampoPorTipo(outroTipo);
      const outroValor = this.formConfirmacao[campoOutro];

      const outroEhCartao =
        outroValor && outroValor.tipoPagamento === this.TIPO_CARTAO_CREDITO;

      if (outroEhCartao) {
        this.formConfirmacao[campoOutro] = null;
      }

      this.reatribuiFormaPagamento(tipo);
    },

    getCampoPorTipo(tipo) {
      const mapa = {
        entrada: 'idFormaPagamentoAVista',
        mensal: 'idFormaPagamentoMensal',
        dinheiro: 'idFormaPagamentoDinheiro',
      };

      return mapa[tipo] || '';
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.buscaFormasPagamento(
      this.dadosProposta.idEmpresa,
      this.dadosProposta.idProposta,
    );
  },
  created() {},
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
